import React, { memo } from 'react';
import { 
  Container, 
  Image, 
  Titulo, 
  Line1, 
  LogoContainer, 

} from './stylebannerbellavista'; 

import fondo from './bellavistafoto.jpg';
import logo from './NSTA M5.png';


const BannerAcademy = () => {
  return (
    <>
      {/* Banner Principal */}
      <Container>
        <Image src={fondo} alt="M5 Montequinto" />
        <Titulo>
          <Line1></Line1>
      <LogoContainer>
  <img src={logo} alt="Logo" />
</LogoContainer>
        </Titulo>
      </Container>

      {/* Banner Inferior con CR SUR */}
{/* Banner Inferior con texto + CR SUR */}


    </>
  );
};

export default memo(BannerAcademy);
